import { Form, FormElement, FormElementData, FormElementTag } from '@/models/Form';
import { Report } from '@/models/Report';

function storePoints(points: any, element: FormElement, answerPoints: string) {
    element.tags.forEach((tag: FormElementTag) => {
        const pnts = parseInt(answerPoints, 10);

        if (points[tag.id]) {
            points[tag.id] += pnts;
        } else {
            points[tag.id] = pnts;
        }
    });
}

export const getters = {
    loading: (store: { loading: boolean }) => {
        return store.loading;
    },
    form: (store: { form: Form | null }) => {
        return store.form;
    },
    report: (store: { report: Report | null }) => {
        return store.report;
    },
    accessCode: (store: { accessCode: string }) => {
        return store.accessCode;
    },
    errors: (store: { errors: string[] }) => {
        return store.errors;
    },
    elements: (store: { elements: FormElement[] }) => {
        return store.elements;
    },
    answers: (store: { answers: { [elementId: number]: any } }) => {
        return store.answers;
    },
    points: (store: {
        elements: FormElement[];
        answers: { [elementId: number]: any };
        tags: { [tagId: number]: FormElementTag };
    }) => {
        const points: any = {};
        store.elements.forEach((element: FormElement) => {
            if (element.tags) {
                switch (element.type) {
                    case 'input-multirange':
                        const rangeAnswers: string[] = store.answers[element.id];

                        if (rangeAnswers) {
                            Object.values(rangeAnswers).forEach((p: string) => {
                                storePoints(points, element, p);
                            });
                        }
                        break;
                    case 'input-options':
                        const optionsAnswers = store.answers[element.id];

                        if (optionsAnswers !== undefined) {
                            if (element.params.isMultiple) {
                                element.params.options.forEach((option: any) => {
                                    if (optionsAnswers.indexOf(option.id) > -1) {
                                        storePoints(points, element, option.points);
                                    }
                                });
                            } else {
                                const option: any = element.params.options.find((o: any) => {
                                    return o.id === optionsAnswers;
                                });
                                storePoints(points, element, option.points);
                            }
                        }
                        break;
                }
            }
        });
        return points;
    },
    tags: (store: {
        elements: FormElement[];
        answers: { [elementId: number]: any };
        tags: { [tagId: number]: FormElementTag };
    }) => {
        return store.tags;
    },
};
